import { render, staticRenderFns } from "./JiCardDesList.vue?vue&type=template&id=c128fc22&scoped=true"
import script from "./JiCardDesList.vue?vue&type=script&lang=js"
export * from "./JiCardDesList.vue?vue&type=script&lang=js"
import style0 from "./JiCardDesList.vue?vue&type=style&index=0&id=c128fc22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c128fc22",
  null
  
)

export default component.exports